import { AuthFetchForm } from "../hooks/useApi";
import { GerarFundamentosRequest, OpmeBundle, ProcedimentoBundle } from "../types/resources.types";

type References = { procedimentos: ProcedimentoBundle[]; opmes: OpmeBundle[] };

export type GenerateAppealResponse = {
  negativa: string;
  textos: Partial<Record<"cdc" | "atoMedico" | "lgpd" | "resolucao", string>> | null;
  referencias: References;
};

// A pesquisa do Gemini passa de 60s (o padrão do useApi); o backend desiste em 280s.
const AI_TIMEOUT_MS = 300_000;

// O backend recebe o JSON em "payload" e, se houver, o arquivo da negativa em "file".
const toForm = (payload: GerarFundamentosRequest, file?: File | null) => {
  const form = new FormData();
  form.append("payload", JSON.stringify(payload));
  if (file) form.append("file", file);
  return form;
};

export const appealsService = {
  // Gera os textos dos fundamentos e as referências bibliográficas do recurso.
  generate: (apiFetchForm: AuthFetchForm, payload: GerarFundamentosRequest, file?: File | null) =>
    apiFetchForm<GenerateAppealResponse>("/recursos/gerar", toForm(payload, file), { signal: AbortSignal.timeout(AI_TIMEOUT_MS) }),

  // Busca de novo só as referências (procedimentos, OPME ou ambos, conforme o payload).
  references: (apiFetchForm: AuthFetchForm, payload: GerarFundamentosRequest, file?: File | null) =>
    apiFetchForm<{ referencias: References }>("/recursos/referencias", toForm(payload, file), { signal: AbortSignal.timeout(AI_TIMEOUT_MS) }),
};
